import type { Locale } from 'antd/es/locale';
import locale from 'antd/es/locale/cs_CZ';
import { mergeDeepRight } from 'ramda';

// NOTE: Ant design translations for CZ lang are incomplete so
// feel free to add translations for what you are missing or want to customize.
// Default translations can be found here: node_modules\antd\lib\locale\default.js

export const csCZ: Locale = mergeDeepRight(locale, {
  Form: {
    defaultValidateMessages: {
      required: 'Zadejte prosím ${label}', // 'Please enter ${label}'
      types: {
        email: 'Email není platný',
        number: '${label} musí být číslo', // '${label} is not a valid number',
        integer: '${label} musí být celé číslo',
      },
      number: {
        min: '${label} musí být alespoň ${min}', // '${label} must be minimum ${min}'
        max: '${label} nesmí být větší než ${max}', // '${label} must be maximum ${max}'
        range: '${label} musí být mezi ${min} a ${max}', // '${label} must be between ${min} and ${max}'
      },
    },
  },
  Pagination: {
    items_per_page: 'záznamů',
  },
  DatePicker: {
    lang: {
      // NOTE: Ant does not offer other way to customize translations in DatePicker, long names are according to design
      shortMonths: [
        'Leden',
        'Únor',
        'Březen',
        'Duben',
        'Květen',
        'Červen',
        'Červenec',
        'Srpen',
        'Září',
        'Říjen',
        'Listopad',
        'Prosinec',
      ],
      shortWeekDays: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
    },
  },
} as Partial<Locale>) as Locale;
